/*

Author: David Biga - All rights reserved - 2015

Imports all critical assets for initialization
*/
import basics from '../helpers/basics';
import user from '../../controllers/user';
import modal from '../../utilities/modal';
import loadScript from '../helpers/load-script';

// #  Import third party libraries
/*loadScript('../assets/js/icheck.min.js', () => {

});
loadScript('../assets/js/datatables.min.js', () => {});*/
/*
// #  TO DO 
var assetsObject = Class.create({
  	initialize: function(routingObject) {
  		this.routingObject = routingObject;
		this.assetsLoaded = false;

		this.loadAssets();
	},
	// #  Load every asset we own
	loadAssets: function()
	{
		// #  Set localized instance to self for later use after ajax call
		var self = this;
		// #  Retrieve data for level assets
		jQuery.when(jQuery(self.preLoaderDOM).fakeLoader(self.preLoaderOptions),jQuery.get( 'app/views/parts/level/tools.html'),jQuery.get( 'app/views/parts/level/toolbar.html'),jQuery.get( 'app/views/parts/level/notifications.html'),jQuery.get( 'app/views/parts/level/information.html'),jQuery.get('app/templates/parts/level/information-template.html'),jQuery.getScript("app/js/engine/room.js"),jQuery.getScript("app/js/engine/canvas.js"), jQuery.getScript("app/js/engine/camera.js"), jQuery.getScript("app/js/engine/gui.js"), jQuery.getScript("app/js/graphic_engine/controllers/floor_plan.js")).done(function(preload,a1,a2,a3,a4,a5,s1,s2,s3,s4){
			jQuery(self.attachDOM).append( a1[0] );
			jQuery(self.attachDOM).append( a2[0] );
			jQuery(self.attachDOM).append( a3[0] );
			jQuery(self.attachDOM).append( a4[0] );
			jQuery(self.attachDOM).append( a5[0] );
			
		});
		// #  Retrieve data for overViewAssests
		jQuery.when(
			jQuery(self.preLoaderDOM).fakeLoader(self.preLoaderOptions),
			jQuery.get('app/views/overview.html'),
			jQuery.get('app/templates/overview-template.html'),
			jQuery.get('app/templates/parts/overview/addbuilding-template.html'),
			jQuery.get('app/views/parts/overview/addbuilding.html'),
			jQuery.get('app/templates/parts/overview/groups-template.html'),
			jQuery.getScript("app/js/engine/views/overview.js"),
			jQuery.getScript("app/js/engine/helpers/overview-helper.js"),
			jQuery.getScript("app/js/graphic_engine/controllers/building.js")
		).done(function(preload,a1,a2,a3,a4,a5,s1,s2,s3){
			// #  Store the ID of the inserted view for removal
			self.removeDOM.push(jQuery(a1[0]).attr('id'));// = jQuery(a1[0]).attr('id');
			// #  append content
			jQuery(self.bodyDOM).append(a1[0]);
			// #  append content
			jQuery(self.bodyDOM).append(a2[0]);
			// #  append content
			jQuery(self.bodyDOM).append(a3[0]);
			// #  append content
			jQuery(self.bodyDOM).append(a4[0]);
			// #  append content
			jQuery(self.bodyDOM).append(a5[0]);
			// #  Store the ID of the inserted view for removal
			self.removeDOM.push(jQuery(a4[0]).attr('id'));
		});
	}
	
});*/


// WEBPACK FOOTER //
// app/core/engine/assets/autoload.js